import OT from '@opentok/client';

import {
  SESSION_STATUS_CONNECTED,
  SESSION_STATUS_RECONNECTING,
  SESSION_STATUS_DISCONNECTED,
} from 'OPENTOK/models/session';

import { INIT_SESSION, UPDATE_SESSION_STATUS } from 'OPENTOK/action_types';
import { createConnection, destroyConnection } from 'OPENTOK/actions/connection';
import { createStream, destroyStream, streamPropertyChanged } from 'OPENTOK/actions/stream';
import { subscribeStream } from 'OPENTOK/actions/subscriber';

const updateSessionStatus = (id, status) => ({
  type: UPDATE_SESSION_STATUS,
  id,
  payload: {
    status,
  },
});

const eventHandlers = (id, dispatch, getState) => ({
  sessionConnected: () => {},

  sessionDisconnected: () => {
    dispatch(updateSessionStatus(id, SESSION_STATUS_DISCONNECTED));
    const env = getState().get('env');
    const roomInfo = getState().get('roomInfo');
    const exitUrlPath = env.get('exitUrlPath');
    const forceReloadOnExit = env.get('forceReloadOnExit');

    window.location.href = exitUrlPath(roomInfo);
    if (forceReloadOnExit) {
      window.location.reload();
    }
  },

  sessionReconnecting: () => {
    dispatch(updateSessionStatus(id, SESSION_STATUS_RECONNECTING));
  },

  sessionReconnected: () => {
    dispatch(updateSessionStatus(id, SESSION_STATUS_CONNECTED));
  },

  streamCreated: (event) => {
    const stream = event.stream;
    dispatch(subscribeStream(id, stream)).then((_) => {
      dispatch(
        createStream(
          event.stream.streamId,
          event.stream,
          event.stream.hasAudio,
          event.stream.hasVideo,
        ),
      );
    });
  },

  streamDestroyed: (event) => {
    dispatch(destroyStream(event.stream.streamId));
  },

  streamPropertyChanged: (event) => {
    dispatch(
      streamPropertyChanged(event.stream.streamId, event.stream.hasAudio, event.stream.hasVideo),
    );
  },

  connectionCreated: (event) => {
    dispatch(createConnection(id, event.connection));
  },

  connectionDestroyed: (event) => {
    dispatch(destroyConnection(event.connection));
  },
});

const initSession = ({ API_KEY, SESSION_ID }) => {
  const session = OT.initSession(API_KEY, SESSION_ID);

  return {
    type: INIT_SESSION,
    id: session.sessionId,
    payload: {
      object: session,
    },
  };
};

export const connectSession = ({ id, TOKEN, optEventHandlers }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const session = getState().getIn(['ot', 'sessions', id, 'object']);
    if (!session) {
      return reject('SESSSION OBJECT IS NOT FOUND');
    }

    session.on(eventHandlers(id, dispatch, getState));
    if (optEventHandlers) {
      session.on(optEventHandlers(id, dispatch));
    }

    session.connect(TOKEN, (err) => {
      if (err) {
        console.error(`ERROR OPENTOK SESSION CONNECTION id:${id} TOKEN:${TOKEN}`);
        reject(err);
      } else {
        dispatch(updateSessionStatus(id, SESSION_STATUS_CONNECTED));
        resolve(id, session);
      }
    });
  });

export const initConnectSession = (API_KEY, SESSION_ID, TOKEN, optEventHandlers) => (dispatch, _) => {
  const { id } = dispatch(initSession({ API_KEY, SESSION_ID }));

  return dispatch(connectSession({ id, TOKEN, optEventHandlers })).then((sessionId, _) => sessionId);
};
